const initialState = {
  packetDetails: {},
};

export const packetDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_PACKET_DETAILS':
      return {
        ...state,
        packetDetails: {
          ...state.packetDetails,
          [action.payload.etchPacketEid]: action.payload.packetDetails
        }
      };
    case 'REMOVE_PACKET_DETAILS':
      const { [action.payload]: removedPacket, ...remainingPackets } = state.packetDetails;
      return {
        ...state,
        packetDetails: remainingPackets
      };
      case 'SET_PACKET_DETAILS':
        return {
            ...state,
            packetDetails: {
                ...state.packetDetails,
                [action.payload.etchPacketEid]: action.payload.packetDetails
            }
        };
    case 'VOID_PACKET_DETAILS':
      // Check if the eid matches the one in the action payload
      if (state.packetDetails[action.payload.eid]?.etchPacket?.eid === action.payload.eid) {
        return {
          ...state,
          packetDetails: {
            ...state.packetDetails,
            [action.payload.eid]: {
              ...state.packetDetails[action.payload.eid],
              etchPacket: {
                ...state.packetDetails[action.payload.eid].etchPacket,
                status: 'void',
              },
            },
          },
        };
      }; 
    // If the eid doesn't match, return the state as is
    return state;
    default: 
      return state;
  }
};

const amendmentInitialState = {
  amendExtend: {
    contracts: [],
    step: 0,
    formId: null,
    selectedIndex: null,
    // amendmentId: null,
    fullForm: null,
    amendmentData: null,
  },
}

export const amendmentReducer = (state = amendmentInitialState, action) => {
  switch (action.type) {
  case 'SET_CONTRACTS':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        contracts: action.payload,
      },
    };
  case 'SET_STEP':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        step: action.payload,
      },
    };
  case 'SET_FORMID':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        formId: action.payload,
      },
    };
  case 'SET_AMENDMENTID':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        amendmentId: action.payload,
      },
    };
  case 'SET_FULLFORM':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        fullForm: action.payload,
      },
    };
  case 'SET_AMENDMENTDATA':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        amendmentData: action.payload,
      },
    };
  case 'FETCH_AMENDMENT_DATA':
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        amendmentData: action.payload,
      },
    };
  case 'UPDATE_AMENDMENTDATA':
  return {
    ...state,
    amendExtend: {
      ...state.amendExtend,
      amendmentData: action.payload,
    },
  };  
  case 'SAVE_AMENDMENT_DATA':
    const { formId, ...amendmentData } = action.payload;

    // Find the contract by formId
    const contractIndex = state.amendExtend.contracts.findIndex(contract => contract.formId === formId);
    if (contractIndex === -1) return state; // Contract not found, return current state
  
    // Clone the contract to avoid direct mutation
    const contract = { ...state.amendExtend.contracts[contractIndex] };
    let amendments = [...(contract.amendments || [])]; // Clone amendments array
  
    // Determine if we're updating an existing amendment or adding a new one
    let amendmentIndex = amendments.findIndex(amendment => amendment.amendmentId === amendmentData.amendmentId);
  
    if (amendmentIndex > -1) {
      // Update existing amendment
      // Correctly spread amendmentData to avoid nesting
      amendments[amendmentIndex] = { ...amendments[amendmentIndex], ...amendmentData };
    } else {
      // Add new amendment by pushing to the cloned array
      amendments.push({ ...amendmentData });
    }
  
    // Update the cloned contract with the new amendments array
    contract.amendments = amendments;
  
    // Clone the contracts array and update the modified contract
    const updatedContracts = state.amendExtend.contracts.map((item, index) => 
      index === contractIndex ? contract : item
    );
  
    // Construct the new state with the updated contracts array
    return {
      ...state,
      amendExtend: {
        ...state.amendExtend,
        contracts: updatedContracts,
      },
    };
    default: 
      return state;
  }
}; 

// export default amendmentReducer; 